<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <div class="pa-4">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <div class="header-card mb-4">
            <div class="d-flex align-center gap-3 mb-2">
              <label style="padding-right: 12px" for="show-header">Header</label>
              <input type="checkbox" v-model="fields['header'].show" id="show-header" />
            </div>
            <ckeditor :editor="editor" v-model="fields['header'].content" :config="editorConfig" />
          </div>
          <div>
            <v-row>
              <v-col cols="12" md="4">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-color']"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields['background-color']" label="Background Color" />
                  <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div style="margin-bottom: 20px">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="pagination-active-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['pagination-active-color']"
                      @change="handleChangePaginationActiveColor"
                    />
                    <v-text-field v-model="fields['pagination-active-color']" label="Pagination Active Color" />
                    <v-btn @click="handleResetPaginationActiveColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div style="margin-bottom: 20px">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="pagination-inactive-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['pagination-inactive-color']"
                      @change="handleChangePaginationInactiveColor"
                    />
                    <v-text-field v-model="fields['pagination-inactive-color']" label="Pagination Inactive Color" />
                    <v-btn @click="handleResetPaginationInactiveColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="mb-4">
            <label class="label-input">Slides Per View</label>
            <p class="text-caption">The viewport is based on the description’s width, not the window’s width.</p>
            <v-row>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.mobile.slidesPerView"
                    label="Mobile"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.tablet.slidesPerView"
                    label="Tablet"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  <v-text-field
                    v-model.number="fields.breakpoints.desktop.slidesPerView"
                    label="Desktop"
                    type="number"
                    :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </div>
          <div>
            <div class="d-flex justify-space-between align-center">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label class="label-input" style="margin-bottom: 0">Media Items</label>
              </div>
              <v-btn small color="primary" @click="handleAddMedia">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Media</span>
              </v-btn>
            </div>
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="card-item-background-color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['card-item-background-color']"
                @change="handleChangeCardItemBackgroundColor"
              />
              <v-text-field v-model="fields['card-item-background-color']" label="Card Item Background Color" />
              <v-btn @click="handleResetCardItemBackgroundColor" small text color="primary"> Reset </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>{{ item.type === 'image' ? 'Image' : 'Video' }} {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveMedia(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-4">
                    <div style="margin-bottom: 8px">Media Type</div>
                    <v-radio-group v-model="item.type" row>
                      <v-radio label="Image" value="image"></v-radio>
                      <v-radio label="Video" value="video"></v-radio>
                    </v-radio-group>
                  </div>

                  <!-- Image Upload -->
                  <div v-if="item.type === 'image'">
                    <div class="mb-4">
                      <div style="margin-bottom: 8px">Image</div>
                      <UploadImage
                        @callback="obj => handleUploadImage(obj, i)"
                        :image="{ imageSrc: item.image }"
                        :height="`200`"
                        :typeUpload="'image'"
                        @callbackDelete="handleRemoveImage(i)"
                      />
                    </div>
                    <div class="mt-8">
                      <div style="margin-bottom: 8px !important">Content</div>
                      <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                    </div>
                  </div>

                  <!-- Video URL -->
                  <div v-if="item.type === 'video'">
                    <div class="d-flex align-center gap-6 mb-4">
                      <v-text-field v-model="item.video" label="Video URL" />
                      <v-btn @click="handlePreviewVideo(i)" text color="primary">
                        <v-icon>mdi-reload</v-icon> Reload
                      </v-btn>
                    </div>
                    <div class="video-wrapper">
                      <div class="wrap-video">
                        <video width="100%" height="auto" autoplay muted loop playsinline :ref="'videoPlayer'">
                          <source data-attribute="card-video" type="video/mp4" :src="item.video" />
                        </video>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { replaceImageUrl } from '../common/utils';
export default {
  name: 'CardMediaSlider',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'background-color': '#F9F9F9',
        'card-item-background-color': '#ffffff',
        topPadding: true,
        bottomPadding: true,
        header: {
          show: false,
          content: '',
        },
        'pagination-active-color': '#000000',
        'pagination-inactive-color': '#cccccc',
        breakpoints: {
          mobile: {
            slidesPerView: 1,
          },
          tablet: {
            slidesPerView: 2,
          },
          desktop: {
            slidesPerView: 3,
          },
        },
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handlePreviewVideo(index) {
      const video = this.$refs.videoPlayer[index];
      if (video) {
        video.load();
        video.play();
      }
    },
    handleAddMedia() {
      const imageUrl = replaceImageUrl(
        'https://cdn.skyfastimg.com/images/2026/02/25/image-699e66d3415a551ac75634fc.webp?w=50&h=50&q=80',
      );
      this.fields['listItem'].push({
        type: 'image',
        video: '',
        image: imageUrl,
        content: `<h3 style="text-align: center"><strong>Title text</strong></h3><p style="text-align: center">Description text</p>`,
      });
    },
    handleRemoveMedia(index) {
      this.fields['listItem'].splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.fields['listItem'][index].image = obj.imageSrc;
    },
    handleRemoveImage(index) {
      this.fields['listItem'][index].image = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '#F9F9F9';
    },
    handleChangeCardItemBackgroundColor(event) {
      this.fields['card-item-background-color'] = event.target.value;
    },
    handleResetCardItemBackgroundColor() {
      this.fields['card-item-background-color'] = '#ffffff';
    },
    handleChangePaginationActiveColor(event) {
      this.fields['pagination-active-color'] = event.target.value;
    },
    handleChangePaginationInactiveColor(event) {
      this.fields['pagination-inactive-color'] = event.target.value;
    },
    handleResetPaginationActiveColor() {
      this.fields['pagination-active-color'] = '#000000';
    },
    handleResetPaginationInactiveColor() {
      this.fields['pagination-inactive-color'] = '#cccccc';
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardMediaSlider03(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 100px !important;
}
::v-deep .ck-editor__editable {
  min-height: 100px !important;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.video-wrapper {
  background: rgba(0, 0, 0, 0.767);
  .wrap-video {
    max-width: 300px;
    margin: 0 auto;
    video {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}

.breakpoint-label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  display: block;
}
</style>
